const DOORS = {
  2: {
    id: '2',
    label: '2',
    labelKey: '2',
  },
  3: {
    id: '3',
    label: '3',
    labelKey: '3',
  },
  4: {
    id: '4',
    label: '4',
    labelKey: '4',
  },
  5: {
    id: '5',
    label: '5',
    labelKey: '5',
  },
  6: {
    id: '6',
    label: '6',
    labelKey: '6',
  },
};

export { DOORS };
